
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import PillarOfOops from './components/content/4PillarOfOops/4PillarOfOops';
import AccessModifier from './components/content/AccessModifier/AccessModifier';
import AdvancedJava from './components/content/AdvancedJava/AdvancedJava';
import Arrays from './components/content/Arrays/Arrays';
import AutoboxingUnboxing from './components/content/AutoboxingUnboxing/AutoboxingUnboxing';
import BreakContinueKeywords from './components/content/BreakContinueKeywords/BreakContinueKeywords';
import ClassesObjects from './components/content/ClassesObjects/ClassesObjects';
import Collections from './components/content/Collections/Collections';
import ConcurrentCollection from './components/content/ConcurrentCollection/ConcurrentCollection';
import ConstructorDestructor from './components/content/ConstructorDestructor/ConstructorDestructor';
import ControlStatements from './components/content/ControlStatements/ControlStatements';
import CoreJava from './components/content/CoreJava/CoreJava';
import DataTypes from './components/content/DataTypes/DataTypes';
import ExceptionHandling from './components/content/ExceptionHandling/ExceptionHandling';
import ForEachLoop from './components/content/ForEachLoop/ForEachLoop';
import FunctionalInterface from './components/content/FunctionalInterface/FunctionalInterface';
import GettingStarted from './components/content/GettingStarted/GettingStarted';
import IfElseSwitch from './components/content/IfElseSwitch/IfElseSwitch';
import InitializerBlock from './components/content/InitializerBlock/InitializerBlock';
import InterfaceAbstractClass from './components/content/InterfaceAbstractClass/InterfaceAbstractClass';
import Java8Features from './components/content/Java8Features/Java8Features';
import JavaBasics from './components/content/JavaBasics/JavaBasics';
import JavaEnvironment from './components/content/JavaEnvironment/JavaEnvironment';
import JDBC from './components/content/JDBC/JDBC';
import JSP from './components/content/JSP/JSP';
import Keywords from './components/content/Keywords/Keywords';
import KeywordsVariables from './components/content/KeywordsVariables/KeywordsVariables';
import LambdaExpressions from './components/content/LambdaExpressions/LambdaExpressions';
import LetsGetStarted from './components/content/LetsGetStarted/LetsGetStarted';
import Loops from './components/content/Loops/Loops';
import MapCollection from './components/content/Map/Map';
import ListCollection from './components/content/List/List';
import MultiThreading from './components/content/MultiThreading/MultiThreading';
import OopsConcepts from './components/content/OopsConcepts/OopsConcepts';
import OptionalClass from './components/content/OptionalClass/OptionalClass';
import ProgrammmingLanguage from './components/content/ProgrammmingLanguage/ProgrammmingLanguage';
import QueueCollection from './components/content/Queue/Queue';
import Recursion from './components/content/Recursion/Recursion';
import RestWebServices from './components/content/RestWebServices/RestWebServices';
import RuntimeLinking from './components/content/RuntimeLinking/RuntimeLinking';
import SerializationDeserialization from './components/content/SerializationDeserialization/SerializationDeserialization';
import Servlet from './components/content/Servlet/Servlet';
import SessionManagement from './components/content/SessionManagement/SessionManagement';
import SetCollection from './components/content/Set/Set';
import SpringBoot from './components/content/SpringBoot/SpringBoot';
import SpringFramework from './components/content/SpringFramework/SpringFramework';
import SpringMVC from './components/content/SpringMVC/SpringMVC';
import StreamAPI from './components/content/StreamAPI/StreamAPI';
import StringBuilderBuffer from './components/content/StringBuilderBuffer/StringBuilderBuffer';
import Strings from './components/content/Strings/Strings';
import Synchronization from './components/content/Synchronization/Synchronization';
import TryWithResources from './components/content/TryWithResources/TryWithResources';
import TypeCasting from './components/content/TypeCasting/TypeCasting';
import WorkingOfAServlet from './components/content/WorkingOfAServlet/WorkingOfAServlet';
import WrapperClass from './components/content/WrapperClass/WrapperClass';

import Disclaimer from './components/Disclaimer/Disclaimer';
import Home from './components/Home/Home';
import Policy from './components/Policy/Policy';
import About from './components/About/About';
import WhyLearnJava from './components/WhyLearnJava/WhyLearnJava';
import InterviewPrograms from './components/InterviewPrograms/InterviewPrograms';
import JavaPrograms from './components/JavaPrograms/JavaPrograms';
import StreamApiPrograms from './components/StreamApiPrograms/StreamApiPrograms';
import VideoTutorials from './components/VideoTutorials/VideoTutorials';
import Contact from './components/Contact/Contact';
import DynamicProgrammingPrograms from './components/DynamicProgrammingPrograms/DynamicProgrammingPrograms';
import DynamicProgramming from './components/content/DynamicProgramming/DynamicProgramming';
import WhatIsDP from './components/content/WhatIsDP/WhatIsDP';
import TypesOfDP from './components/content/TypesOfDP/TypesOfDP';
import LinearDP from './components/content/LinearDP/LinearDP';
import KadaneAlgorithm from './components/content/KadaneAlgorithm/KadaneAlgorithm';
import Knapsack from './components/content/01Knapsack/01Knapsack';
import UnboundedKnapsack from './components/content/UnboundedKnapsack/UnboundedKnapsack';
import Subsequence from './components/content/Subsequence/Subsequence';


const AppRouter = () => {
  return (
      <ErrorBoundary fallback={<p>Something went wrong</p>}>
      <BrowserRouter>
        <Routes>
          <Route path="/lets-get-started"  element={<LetsGetStarted />} />
          <Route path="/getting-started"  element={<GettingStarted />} />
          <Route path="/java-basics"  element={<JavaBasics />} />
          <Route path="/programming-language"  element={<ProgrammmingLanguage />} />
          <Route path="/data-types"  element={<DataTypes />} />
          <Route path="/keywords-variables"  element={<KeywordsVariables />} />
          <Route path="/recursion"  element={<Recursion />} />
          <Route path="/runtime-linking"  element={<RuntimeLinking />} />
          <Route path="/control-statements"  element={<ControlStatements />} />
          <Route path="/if-else-switch"  element={<IfElseSwitch />} />
          <Route path="/loops"  element={<Loops />} />
          <Route path="/break-continue-keywords"  element={<BreakContinueKeywords />} />
          <Route path="/oops-concepts"  element={<OopsConcepts />} />
          <Route path="/classes-objects"  element={<ClassesObjects />} />
          <Route path="/access-modifier"  element={<AccessModifier />} />
          <Route path="/4-pillars-of-oops"  element={<PillarOfOops />} />
          <Route path="/constructors-destructors"  element={<ConstructorDestructor />} />
          <Route path="/initializer-block"  element={<InitializerBlock />} />
          <Route path="/static-this-super-final-keyword"  element={<Keywords />} />
          <Route path="/core-java"  element={<CoreJava />} />
          <Route path="/java-environment"  element={<JavaEnvironment />} />
          <Route path="/strings"  element={<Strings />} />
          <Route path="/arrays"  element={<Arrays />} />
          <Route path="/collections"  element={<Collections />} />
          <Route path="/list"  element={<ListCollection />} />
          <Route path="/queue"  element={<QueueCollection />} />
          <Route path="/set"  element={<SetCollection />} />
          <Route path="/map"  element={<MapCollection />} />
          <Route path="/concurrent-collection"  element={<ConcurrentCollection />} />
          <Route path="/exception-handling"  element={<ExceptionHandling />} />
          <Route path="/multi-threading"  element={<MultiThreading />} />
          <Route path="/wrapper-class"  element={<WrapperClass />} />
          <Route path="/autoboxing-unboxing"  element={<AutoboxingUnboxing />} />
          <Route path="/type-casting"  element={<TypeCasting />} />
          <Route path="/interface-abstract-class"  element={<InterfaceAbstractClass />} />
          <Route path="/advanced-java"  element={<AdvancedJava />} />
          <Route path="/synchronization"  element={<Synchronization />} />
          <Route path="/serialization-deserialization"  element={<SerializationDeserialization />} />
          <Route path="/jdbc"  element={<JDBC />} />
          <Route path="/servlet"  element={<Servlet />} />
          <Route path="/working-of-a-servlet"  element={<WorkingOfAServlet />} />
          <Route path="/session-management"  element={<SessionManagement />} />
          <Route path="/jsp"  element={<JSP />} />
          <Route path="/try-with-resources"  element={<TryWithResources />} />
          <Route path="/java-8-features"  element={<Java8Features />} />
          <Route path="/for-each-loop"  element={<ForEachLoop />} />
          <Route path="/lambda-expressions"  element={<LambdaExpressions />} />
          <Route path="/optional-class"  element={<OptionalClass />} />
          <Route path="/functional-interface"  element={<FunctionalInterface />} />
          <Route path="/string-builder-buffer-tokenizer"  element={<StringBuilderBuffer />} />
          <Route path="/stream-api"  element={<StreamAPI />} />
          <Route path="/spring-framework"  element={<SpringFramework />} />
          <Route path="/spring-mvc"  element={<SpringMVC />} />
          <Route path="/spring-boot"  element={<SpringBoot />} />
          <Route path="/rest-web-services"  element={<RestWebServices />} />
          <Route path="/dynamic-programming"  element={<DynamicProgramming />} />
          <Route path="/what-is-dp"  element={<WhatIsDP />} />
          <Route path="/types-of-dp"  element={<TypesOfDP />} />
          <Route path="/linear-dp"  element={<LinearDP />} />
          <Route path="/kadane-algorithm"  element={<KadaneAlgorithm />} />
          <Route path="/01-knapsack"  element={<Knapsack />} />
          <Route path="/unbounded-knapsack"  element={<UnboundedKnapsack />} />
          <Route path="/subsequence"  element={<Subsequence />} /> 

          <Route path="/about" element={<About />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<Policy />} />
          <Route path="/why-learn-java" element={<WhyLearnJava />} />
          <Route path="/interview-programs" element={<InterviewPrograms />} />
          <Route path="/java-programs" element={<JavaPrograms />} />
          <Route path="/stream-api-programs" element={<StreamApiPrograms />} />
          <Route path="/dp-programs" element={<DynamicProgrammingPrograms />} />
          <Route path="/video-tutorials" element={<VideoTutorials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default AppRouter;
